// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart-container[data-v-7c792c69] {\n  position: relative;\n  height: 50vh;\n  overflow: hidden;\n}", ""]);
// Exports
module.exports = exports;
